// extracted by mini-css-extract-plugin
export default {"input":"ChartDatalist_input__Y4L5V"};